import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab, Box } from "@mui/material";
import * as React from "react";
import useTabParam from '../../hooks/useTabParam';
import ClickPostWebhook from "./ClickpostWebhook";
import EasyecomWebhook from "./EasyecomWebhook";
import LimeChatWebhook from "./LimeChatWebhook";
import WebEngageWebhook from "./WebengageWebhook";
import PageTitle from "../../components/PageTitle";
import { T } from "./webhookUi";
import SyncAltOutlinedIcon from "@mui/icons-material/SyncAltOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";

const TABS = [
  { value: "1", label: "Order Status Updates", icon: <SyncAltOutlinedIcon sx={{ fontSize: 18 }} /> },
  { value: "2", label: "Easyecom", icon: <StorefrontOutlinedIcon sx={{ fontSize: 18 }} /> },
  { value: "3", label: "LimeChat", icon: <ChatOutlinedIcon sx={{ fontSize: 18 }} /> },
  { value: "4", label: "Webengage", icon: <CampaignOutlinedIcon sx={{ fontSize: 18 }} /> },
];

function WebHooks() {
  const [value, setValue] = useTabParam("1");
  const handleChange = (_e, v) => setValue(v);

  return (
    <Box>
      <PageTitle>Merchant Webhooks</PageTitle>
      <TabContext value={value}>
        <Box sx={{
          bgcolor: T.WHITE, border: `1px solid ${T.BORDER}`, borderRadius: '14px',
          boxShadow: '0 1px 3px rgba(16,24,40,0.06)', px: 1, mb: 2,
        }}>
          <TabList
            onChange={handleChange}
            variant="scrollable"
            allowScrollButtonsMobile
            TabIndicatorProps={{ sx: { height: 3, borderRadius: '3px 3px 0 0', bgcolor: T.BLUE } }}
            sx={{
              minHeight: 52,
              "& .MuiTab-root": {
                minHeight: 52, textTransform: 'none', fontFamily: T.FONT, fontWeight: 600,
                fontSize: 13.5, color: T.MUTED, px: 2.5, gap: 0.75,
                "&:hover": { color: T.NAVY, bgcolor: 'rgba(21,101,192,0.04)' },
                "&.Mui-selected": { color: T.BLUE, fontWeight: 700 },
              },
            }}
          >
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} icon={t.icon} iconPosition="start" />
            ))}
          </TabList>
        </Box>

        <TabPanel value="1" sx={{ p: 0 }}><ClickPostWebhook /></TabPanel>
        <TabPanel value="2" sx={{ p: 0 }}><EasyecomWebhook /></TabPanel>
        <TabPanel value="3" sx={{ p: 0 }}><LimeChatWebhook /></TabPanel>
        <TabPanel value="4" sx={{ p: 0 }}><WebEngageWebhook /></TabPanel>
      </TabContext>
    </Box>
  );
}

export default WebHooks;
